import { credentials, UserResponseModel } from "src/models/general-models";
import { ContactModel, PeopleObject, tokenObject } from "src/models/contact-models";
import { showSuccessAlert, showErrorAlert } from "src/loaders/NotificationLoader";
import { ExecuteAPI_Select, API_EndPoints, ExecuteAPI_Update } from "./onit-server-utils";

export async function checkSession() {
    return await ExecuteAPI_Select<any>({}, API_EndPoints.CONTACT.CheckSession, "", true)
}

export async function getTokenForRootUser(credentials: credentials) {
    return await ExecuteAPI_Select<tokenObject>({ credentials }, API_EndPoints.CONTACT.Token, "")
}

export async function authenticateUser(credentials: credentials, otpBySms: boolean, instance?: string) {
    return await ExecuteAPI_Select<PeopleObject[]>({ credentials, otpBySms }, API_EndPoints.CONTACT.AuthenticateUser, "", true, false, instance)
}

export async function authenticateUserForApp(credentials: credentials) {
    return await ExecuteAPI_Select<PeopleObject[]>({ credentials }, API_EndPoints.CONTACT.AuthenticateUserForApp, "", true)
}

export async function verifyOTP(otp: number, otpBySms?: boolean, instance?: string) {
    return await ExecuteAPI_Select<PeopleObject[]>({ otp: otp, otpBySms }, API_EndPoints.CONTACT.VerifyOTP, "", false, false, instance)
}

export async function resendOTP(otpBySms?: boolean, instance?: string) {
    return await ExecuteAPI_Select<PeopleObject[]>({ otpBySms }, API_EndPoints.CONTACT.ResendOTP, "", false, false, instance)
}

export async function ChangePassword(contactName: string, newPassword: string) {
    return await ExecuteAPI_Update({ contactName, newPassword }, API_EndPoints.CONTACT.ChangePasswordFromAccounts, "").then((res) => {
        showSuccessAlert("Password changed Successfully.")
    }).catch(err => {
        showErrorAlert("Error occured while changing Password.");
    });;
}

export async function ChangePasswordEmail(expiryInMinutes: number, userOntology: string) {
    return await ExecuteAPI_Update({ expiryInMinutes, userOntology }, API_EndPoints.CONTACT.ChangePasswordEmail, "").then((res) => {
        return res;
        // showSuccessAlert("Email sent Successfully.")
    }).catch(err => {
        showErrorAlert("Error occured while sending Email.");
    });
}

export async function fetchPeople(buildingName?: string, contactNames?: string[]) {
    return await ExecuteAPI_Select<PeopleObject[]>({ buildingName, contactNames }, API_EndPoints.CONTACT.FetchSingleUser, "", true)
}

export async function checkUserExists_Mongo(username?: string, email?: string) {
    return await ExecuteAPI_Select<UserResponseModel>({ username, email }, API_EndPoints.CONTACT.CheckUserExists_Mongo, "", true, true)
}

export async function checkInstanceExists_Mongo(instance: string) {
    return await ExecuteAPI_Select<UserResponseModel>({ instance }, API_EndPoints.CONTACT.CheckInstanceExists_Mongo, "", true)
}

export async function fetchGuestUser(userName: string) {
    return await ExecuteAPI_Select<ContactModel>({ userName }, API_EndPoints.CONTACT.FetchGuestUser, "", true)
}

export async function SendEmailForgetPassword(to: string, toUser: string, key: string) {
    return await ExecuteAPI_Update({ to, toUser, key }, API_EndPoints.CONTACT.SendEmailForgetPassword, "");
}

export async function GetEmailNotification(key: string) {
    return await ExecuteAPI_Select<any>({ key }, API_EndPoints.CONTACT.GetEmailNotification, "", true)
}

export async function InsertContact(buildingName: string, contact: ContactModel, isEdit: boolean, instance: string): Promise<ContactModel> {
    return await ExecuteAPI_Update<ContactModel>({ buildingName, contact, isEdit },
        instance == "GuestAccess" ? API_EndPoints.CONTACT.InsertGuestUser : API_EndPoints.CONTACT.InsertContact,
        "", instance).then((newUser: ContactModel) => {
            showSuccessAlert(`Contact Record ${isEdit ? "Updated" : "Added"} Successfully.`)
            return newUser;
        }).catch(err => {
            showErrorAlert("Error occured while saving Contact Record.");
            return Object();
        });
}

export async function addInstanceInfo_Mongo(instance: string, username: string): Promise<UserResponseModel> {
    return await ExecuteAPI_Update<UserResponseModel>({ instance, username }, API_EndPoints.CONTACT.AddInstanceInfo_Mongo, "").then((res: UserResponseModel) => {
        if (res.code == 200)
            showSuccessAlert(`User Instance Added Successfully.`);
        else
            showErrorAlert(res.message);
        return res;
    }).catch(err => {
        showErrorAlert("Error occured while saving Contact Record.");
        return Object();
    });
}



// WEBPACK FOOTER //
// ./src/server/utils/contact-utils.ts